import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { ROUTER_PATHS, transformarAEventosFullCalendar } from "@/shared";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { Planificador } from "@/shared/interfaces/erp/mantenimiento-operaciones";
import { usePlanificadorStore } from "@/store/erp";
import { useUiStore } from "@/store/ui";
import { FullCalendarComponent } from "./FullCalendarComponente";
import { useEmpleadoStore } from "@/store/erp/empleado";

export interface BlockUnblockTimeProps { }

const BlockUnblockTime: React.FC<BlockUnblockTimeProps> = ({ }) => {
  const navigate = useNavigate();
  const returnUrlPlanificadoresPage =
    ROUTER_PATHS.mantenimientoOperaciones.planificadorNav;
  ///* global state ----------------
  const setAlert = useUiStore((s) => s.setAlert);
  const planificador = usePlanificadorStore(
    (s) => s.selectedPlanificador
  ) as Planificador;
  const isFetchingEvents = usePlanificadorStore((s) => s.isFetchingEvents);
  const setEvents = usePlanificadorStore((s) => s.setEvents);

  const empladoColor = useEmpleadoStore(s => s.empladoColor)
  ///* handlers ----------------
  if (!planificador) return null;

  try {
    setEvents(transformarAEventosFullCalendar(planificador.time_map, empladoColor));
  } catch (error) {
    setAlert(true, "TimeMap invalido", AlertSeverityEnum.error);
    navigate(returnUrlPlanificadoresPage, { replace: true });
  }

  if (isFetchingEvents) return null;

  return (
    <Grid item xs={12}>
      <FullCalendarComponent planificadorId={planificador.id_planificador!} />
    </Grid>
  );
};

export default BlockUnblockTime;
